import { render, staticRenderFns } from "./BathroomCreation.vue?vue&type=template&id=4961909c&scoped=true"
import script from "./BathroomCreation.vue?vue&type=script&lang=js"
export * from "./BathroomCreation.vue?vue&type=script&lang=js"
import style0 from "./BathroomCreation.vue?vue&type=style&index=0&id=4961909c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4961909c",
  null
  
)

export default component.exports